import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ReportingShellContainerBaseConfig } from '../../base';
import {
    ReportingSidebarContainerProps,
    ReportingSidebarControllerProps,
} from './reportingSidebarProps';
import {
    ReportingSidebarController,
    ReportingSidebarLoader,
    ReportingSidebarStateProvider,
} from './reportingSidebarInterface';
import { HiOutlineHome } from 'react-icons/hi';
import { GoWorkflow } from 'react-icons/go';

export function createReportingSidebarContainer(
    config: ReportingShellContainerBaseConfig &
        Pick<ReportingSidebarControllerProps, 'navigation'>,
    loader: ReportingSidebarLoader,
    controller: ReportingSidebarController
): React.FC<ReportingSidebarContainerProps> {
    const {
        context: { useContext },
        repository: { research: repository },
    } = config;

    return ({ as: View, ...containerProps }) => {
        const context = useContext();
        const navigate = useNavigate();
        const data = loader.useLoad(context, containerProps);
        const state = config.state.layout.useState(context);
        const [sidebarWidthLocal, setSidebarWidthLocal] = useState(
            state.value.sidebarWidth
        );

        const mutation = {
            content: {
                create: repository.document.useCreate(context),
            },
        };

        const handleCreateDocument = async (folderId: string) => {
            // Create a new document via the API
            const response = await mutation.content.create.mutateAsync({
                title: 'Untitled',
                type: 'document',
                publish: false,
                blocks: [], // Empty content blocks
                // Note: folderId represents the status/folder (workspace, draft, etc.)
                // This will be handled by the backend based on the folder context
            });
            // Navigate to the new document
            navigate(`/reporting/reports/${response.id}`);
        };

        const viewProps = controller.useProps(context, data, {
            ...containerProps,
            width: {
                value: sidebarWidthLocal,
                onChange(value) {
                    setSidebarWidthLocal(value);
                    state.onChange({ ...state.value, sidebarWidth: value });
                },
            },
            navigation: {
                items: config.navigation.items,
            },
            actions: {
                onCreateDocument: handleCreateDocument,
            },
        });

        return <View {...viewProps} />;
    };
}
